import {
  PlatformsComposabilitySection,
  PlatformsIntroSection,
  PlatformsLabelsSection,
} from '@/components/platforms';
import Head from 'next/head';
import dynamic from 'next/dynamic';

const title = 'Api to access web3 protocols security data | Trustblock';
const description =
  'Use our labels & API to access web3 protocols security data & enhance your product.';

const PlatformsWidgetSection = dynamic(
  () =>
    import(
      '../components/platforms/PlatformsWidgetSection/PlatformsWidgetSection'
    ),
  { ssr: false },
);

function Platforms() {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="title" content={title} />
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={description} />
        <link rel="canonical" href="https://trustblock.run/sec-api" />
      </Head>
      <PlatformsIntroSection />
      <PlatformsLabelsSection />
      <PlatformsWidgetSection />
      <PlatformsComposabilitySection />
    </>
  );
}

export default Platforms;
